
import { Component, Vue, Prop } from "nuxt-property-decorator";
import { HeaderData } from "~/types/components";

@Component
export default class TheHeaderAstagiudiziaria extends Vue {
  @Prop() headerdata!: HeaderData;
}
